import { createSlice } from "@reduxjs/toolkit"

const initState = {
    user: JSON.parse(localStorage.getItem('user')) || {},
    token: localStorage.getItem('token')
}


let authSlice = createSlice({
    name: 'auth',
    initialState: initState,
    reducers: {
        setAuth: function (state, action) {
            localStorage.setItem('user',JSON.stringify(action.payload.user))
            localStorage.setItem('token', action.payload.token);
            //state.user = action.payload.user
            //state.token =  action.payload
        },

        logoutUser: (state,action)=>{
            localStorage.removeItem('token')
            localStorage.removeItem('user')
        }


    }
})

export const { setAuth,logoutUser } = authSlice.actions;

export default authSlice.reducer;